import { useMemo, useState } from 'react';
import { Modal, AutoComplete } from 'antd';
import { useStoreState, useStoreActions } from '../../store';
import { useHistory } from 'react-router-dom';
import type { NavigationLink } from '~/store/navigation/types';
import { useNavigation } from '~/hooks/useNavigation';
import { flattenNavPath } from '~/store/navigation';
export const MODAL_KEY = 'globalSearchModal';

const updateFilterPaths = (originalPaths: NavigationLink[], searchText: string): NavigationLink[] => {
  return originalPaths.filter((p: NavigationLink, idx: number) =>
    p.name.toLowerCase().startsWith(searchText.toLowerCase()),
  );
};

export const GlobalSearchComponent = () => {
  const open = useStoreState((state) => state.navigation.modals[MODAL_KEY]?.open);
  const closeModal = useStoreActions((actions) => actions.navigation.toggleModal);
  const navigation = useNavigation();
  const flattenedNavigation = useMemo(() => {
    const flattened = flattenNavPath(navigation);
    // filter out dupes
    return flattened.filter((p, idx) => flattened.findIndex((val) => val.name === p.name) === idx);
  }, [navigation]);
  const [filterPaths, setFilterPaths] = useState(flattenedNavigation);

  const sessionPartnerUrl = useStoreState((state) => state.session.user?.sessionPartnerUrl);
  const history = useHistory();
  const [searchValue, setValue] = useState('');
  const navigateFromSearch = (value: any, option: object) => {
    const routeInfo = filterPaths.find((route) => route.name === value);

    if (routeInfo?.external) {
      window.open(routeInfo.path, '_blank', 'noopener,noreferrer');
    } else if (routeInfo) {
      const base = sessionPartnerUrl && routeInfo.path.includes(sessionPartnerUrl) ? `` : `/${sessionPartnerUrl}/`;
      history.push(`${base}${routeInfo.path}`);
    } else {
      history.push(`/${sessionPartnerUrl}/delivery-reporting/shipment-search/${value}`);
    }
    closeModal({ key: MODAL_KEY, open: false });
    setValue('');
  };
  const handleReturn = (event: any) => {
    // this will compete with the autocomplete
    // which blocks you from being able to select a
    // page with arrows + enter
    // the best solution I could come up with is only search shipments when there
    // are no possible autocompletes remaining
    if (!filterPaths.length && event.key === 'Enter') {
      const value = event.target.value;
      navigateFromSearch(value, {});
    }
  };

  const filterResults = (searchText: string) => {
    setValue(searchText);
    setFilterPaths(updateFilterPaths(flattenedNavigation, searchText));
  };
  const handleClose = () => {
    setFilterPaths(flattenedNavigation);
    closeModal({ key: MODAL_KEY, open: false });
  };
  return (
    <Modal open={open} footer={null} onCancel={handleClose}>
      {/*
            This is a bit of a hack to force the search bar to rerender.
            The ant AutoComplete component is doing some stuff after submit that I don't want and isn't
            cofigurable(to the best of my knowledge). By forcing a rerender instead of relying on modal visiblity
            the input will always focus when the modal is opened and it will clear the text input after submit.
            Would like to refactor at some point
             */}
      {open && (
        <>
          <AutoComplete
            id={'main-search-input'}
            autoFocus={true}
            style={{ width: '90%' }}
            placeholder="Search Shipium / Page / Shipment / Order ID"
            dataSource={filterPaths.map((i) => i.name)}
            onSelect={navigateFromSearch}
            onChange={filterResults}
            onKeyUp={handleReturn}
            value={searchValue}
            dropdownMatchSelectWidth={false}
          />
          <p style={{ fontSize: 10, fontWeight: 0.5 }}> Open search window with cmd + k</p>
        </>
      )}
    </Modal>
  );
};
